import React, { useState, useEffect } from 'react';
import 'react-circular-progressbar/dist/styles.css';

import {
  Card,
  Grid,
  Paper,
  Typography,
  CircularProgress,
} from '@material-ui/core';

import { Box, Flex } from 'rebass';
import api from '../../../services/api';
import { useStyles } from '../../styles';
import Modal from '../../../components/Modal';
import ProjectCard from '../../../components/ProjectCard';
import Paginate from '../../../components/Paginate';
import SearchBar from '../../../components/SearchBar';
import Header from '../../../components/Header';
import DetailModal from './DetailModal';

const LifeCicleBox = () => {
  const classes = useStyles();
  const token = localStorage.getItem('@icep-app/token');
  const unity_id = localStorage.getItem('@icep-app/unity');
  const [progress, setProgress] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [boxItemsData, setBoxItemsData] = useState([]);
  const [detailId, setDetailId] = useState();
  const [filterParams] = useState({});

  const [totalRows, setTotalRows] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(0);

  const params = {
    format: 'all',
    cycle: '0',
    type: 'all',
  };

  useEffect(() => {
    async function fetch() {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const resp = await api.get(
        `/boxitems/unity/${unity_id}/format/${params.format}/cycle/${params.cycle}/box/${params.type}/`,
      );

      setTotalRows(resp.data.metadata.totalRows);
      setTotalPages(resp.data.metadata.totalPages);
      setBoxItemsData(resp.data.source);
      setProgress(false);
    }
    fetch();
  }, [params.cycle, params.format, params.type, token, unity_id]);

  const handleFilter = async (item) => {
    setProgress(true);
    let typeId = item.type ? item.type.value : params.type;
    let cycleId = item.cycle ? item.cycle : params.cycle;
    let formatId = item.format ? item.format.value : params.format;

    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    const resp = await api.get(
      `/boxitems/unity/${unity_id}/format/${formatId}/cycle/${cycleId}/box/${typeId}/`,
    );
    setTotalRows(resp.data.metadata.totalRows);
    setTotalPages(resp.data.metadata.totalPages);
    setBoxItemsData(resp.data.source);
    setProgress(false);
  };

  const handleClear = async (item) => {
    setProgress(true);
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    const resp = await api.get(
      `/boxitems/unity/${unity_id}/format/${params.format}/cycle/${params.cycle}/box/${params.type}/`,
    );
    setTotalRows(resp.data.metadata.totalRows);
    setTotalPages(resp.data.metadata.totalPages);
    setBoxItemsData(resp.data.source);
    setProgress(false);
  };

  const handleOpenModal = async (id) => {
    setDetailId(id);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const onPageChange = async (item) => {
    setPage(item.selected);
  };

  useEffect(() => {
    async function fetch() {
      setProgress(true);
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const resp = await api.get(
        `/boxitems/unity/${unity_id}/format/${params.format}/cycle/${
          params.cycle
        }/box/${params.type}?page=${page + 1}`,
      );

      setBoxItemsData(resp.data.source);
      setProgress(false);
    }
    fetch();
  }, [page, params.cycle, params.format, params.type, token, unity_id]);

  return (
    <>
      <Grid className={classes.qualityRoot}>
        <Grid alignItems="flex-end" container justify="space-between">
          <Header title="Matrizaria" subtitle="Vida Útil - Caixas" />
          <SearchBar
            label=" Caixas"
            onClear={handleClear}
            endpoint="/boxes"
            onFilter={handleFilter}
            className={classes.filterButton}
            filterParams={filterParams}
          />
        </Grid>
        {progress ? (
          <Paper className={classes.paper}>
            <Box container justifyContent="center" alignItems="center">
              <Flex justifyContent="center" alignItems="center">
                <CircularProgress
                  className={classes.circularProgress}
                  color="secondary"
                />
              </Flex>
            </Box>
          </Paper>
        ) : (
          <div className={classes.results}>
            <Flex justifyContent="space-between">
              <Box>
                <Typography color="textSecondary" gutterBottom variant="body2">
                  Total de {totalRows} registros econtrados. Pagina {page + 1}{' '}
                  de {totalPages}
                </Typography>
              </Box>
            </Flex>
            {boxItemsData.length > 0 ? (
              boxItemsData.map((row) => (
                <ProjectCard
                  key={row.id}
                  type="box"
                  data={row}
                  openModal={handleOpenModal}
                />
              ))
            ) : (
              <Card className={classes.container}>
                <Typography
                  className={classes.circularProgress}
                  align="center"
                  variant="body2"
                  color="textPrimary"
                >
                  Sem dados
                </Typography>
              </Card>
            )}
          </div>
        )}
        <div className={classes.paginate}>
          <Paginate
            pageCount={totalPages}
            onPageChange={onPageChange}
            pageRangeDisplayed={4}
          />
        </div>
      </Grid>
      <Modal
        title="Vizualizar"
        subheader="Ultimas recuperações"
        open={openModal}
        handleClose={() => handleCloseModal(false)}
        component={
          <DetailModal
            id={detailId}
            type="box"
            label="Caixa"
            typeItem="box_item"
            endpoint={'/boxitems'}
          />
        }
      />
    </>
  );
};
export default LifeCicleBox;
